export function blobToDataUrl(blob: Blob): Promise<string | ArrayBuffer> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      resolve(reader.result);
    };

    if (!blob) {
      reject();
    }

    reader.readAsDataURL(blob);
  });
}
